import api from './Api';
import { IArquivoRetorno } from '../interfaces/IArquivoRetorno';

interface FiltrosBook {
    isFornecedor?: boolean;
    isTributo?: boolean;
    isRetido?: boolean;
    isBanco?: boolean;
    isSalario?: boolean;
    isImobilizado?: boolean;
    isEstoque?: boolean;
    isFolha?: boolean;
    isCapitalSocial?: boolean;
    isEmprestimo?: boolean;
    ignorarContasSemMovimentacao?: boolean;
    ocultarCartoes100Conciliados?: boolean;
}

interface GerarPdfRequest {
    esteiraId: number;
    empresaId: number;
    inicio: string;
    fim: string;
    mostrarContaReferencial: boolean;
    // Filtros
    isFornecedor?: boolean;
    isTributo?: boolean;
    isRetido?: boolean;
    isBanco?: boolean;
    isSalario?: boolean;
    isImobilizado?: boolean;
    isEstoque?: boolean;
    isFolha?: boolean;
    isCapitalSocial?: boolean;
    isEmprestimo?: boolean;
    ignorarContasSemMovimentacao?: boolean;
    ocultarCartoes100Conciliados?: boolean;
    contasSelecionadas?: number[];
}

interface GerarPdfResponse {
    operacaoId: number;
    arquivoRetornoId: number;
}

export interface ContaRelatorioResumido {
    id: number;
    contaReferencial: string;
    contaEmpresa: string;
    descricaoEmpresa: string | null;
}

class ArquivoRetornoService {
    async gerar(esteiraId: number, request: Omit<GerarPdfRequest, 'esteiraId'>): Promise<GerarPdfResponse> {
        const { data } = await api.post<GerarPdfResponse>(`ArquivoRetorno/gerar/${esteiraId}`, {
            ...request,
            esteiraId
        });
        return data;
    }

    async listar(esteiraId: number): Promise<IArquivoRetorno[]> {
        const { data } = await api.get<IArquivoRetorno[]>(`ArquivoRetorno/${esteiraId}`);
        return data;
    }

    async obterUrlDownload(arquivoRetornoId: number): Promise<string> {
        const { data } = await api.get<{ url: string }>(`ArquivoRetorno/download/${arquivoRetornoId}`);
        return data.url;
    }

    async listarContas(esteiraId: number, offset: number, pageSize: number, query?: string): Promise<ContaRelatorioResumido[]> {
        const params: any = { offset, pageSize };
        if (query) params.q = query;
        const { data } = await api.get<ContaRelatorioResumido[]>(`ArquivoRetorno/contas/${esteiraId}`, { params });
        return data;
    }

    async listarPorCartao(relatorioId: number): Promise<IArquivoRetorno[]> {
        const { data } = await api.get<IArquivoRetorno[]>(`ArquivoRetorno/cartao/${relatorioId}`);
        return data;
    }

    async gerarXlsxCartao(relatorioId: number): Promise<void> {
        await api.post(`ArquivoRetorno/gerar-xlsx/${relatorioId}`);
    }

    async gerarXlsxTodosLancamentos(esteiraId: number): Promise<void> {
        await api.post(`ArquivoRetorno/gerar-xlsx-todos-lancamentos/${esteiraId}`);
    }

    async listarXlsxTodosLancamentos(esteiraId: number): Promise<IArquivoRetorno[]> {
        const { data } = await api.get<IArquivoRetorno[]>(`ArquivoRetorno/xlsx-todos-lancamentos/${esteiraId}`);
        return data;
    }

    async gerarExportAlteracao(esteiraId: number, alteracaoIds?: number[]): Promise<{ arquivoRetornoId: number; avisos: string[] }> {
        const { data } = await api.post<{ arquivoRetornoId: number; avisos: string[] }>(
            `ArquivoRetorno/gerar-export-alteracao/${esteiraId}`,
            alteracaoIds && alteracaoIds.length > 0 ? { alteracaoIds } : {}
        );
        return data;
    }

    async listarExportAlteracao(esteiraId: number): Promise<IArquivoRetorno[]> {
        const { data } = await api.get<IArquivoRetorno[]>(`ArquivoRetorno/alteracao-lancamento/${esteiraId}`);
        return data;
    }
}

export type { FiltrosBook };
export default new ArquivoRetornoService();

